<template>
    <div>
        <div class="contrainer">
            <div class="row text-modal-redeem">
                <div class="col-12 text-center">
                    <div class="title">
                        ยืนยันการแลกรางวัล
                    </div>
                    <div class="detail">
                        คุณต้องการยืนยันการแลกรางวัลโดยใช้<br />
                        <span class="point">
                            {{ campaign.pointPerUnit }} คะแนน
                        </span>
                        <span class="ml-1">
                            <svg
                                style="position: absolute;"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M16.655 6.509a9.391 9.391 0 0 1-1.232 2.584c0 .064.004.127.004.193a6.677 6.677 0 1 1-5.168-6.506c.228-.675.505-1.175.807-1.545l-.022-.006a8.42 8.42 0 0 0-.694-.166l-.142-.026a8.46 8.46 0 0 0-2.914 0l-.141.026a8.494 8.494 0 0 0-.917.232 8.534 8.534 0 0 0-1.274.52 8.012 8.012 0 0 0-.378.206A8.413 8.413 0 0 0 .817 6.599a8.328 8.328 0 0 0-.27.998 8.437 8.437 0 0 0 .339 4.567 8.34 8.34 0 0 0 1.803 2.899 8.365 8.365 0 0 0 4.464 2.444l.141.026a8.42 8.42 0 0 0 2.914 0l.142-.026a8.515 8.515 0 0 0 .694-.166 8.395 8.395 0 0 0 5.843-6.066 8.42 8.42 0 0 0-.232-4.766z"
                                    fill="#000"
                                />
                                <path
                                    d="M10.53 4.301c-.315 1.882-.984 3.703-2.46 5.226-.698.725-1.71 1.486-2.665 1.776h2.049c3.767 0 5.638-.595 6.919-1.91 2.312-2.408 2.281-5.037 2.78-8.603h-3.478c-.884.002-2.576.046-3.146 3.511z"
                                    fill="#4D341C"
                                />
                            </svg>
                        </span>
                    </div>
                    <!-- <img :src="campaign.fullImageUrl" class="img-detail" /> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
export default {
    name: "DefaultConfirmRedeem",
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function() {
        return {
            msg: ""
        };
    },
    created: function() {
        var minutes = this.campaign.minutesValidAfterUsed;
        if (minutes) {
            let days = "";
            let hours = "";
            let result = "";
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) {
                    days = Math.floor(hours / 24);
                }
            }

            if (days > 0) {
                result += days + " " + this.lbl.date.days + " ";
            }

            if (hours / 24 > 0) {
                result += (hours % 24) + " " + this.lbl.date.hours + " ";
            }

            if (minutes / 60 > 0) {
                result += (minutes % 60) + " " + this.lbl.date.minutes_short;
            }

            this.msg = Util.stringFormat(
                this.lbl.confirm_redeem.defualt_have_time,
                result
            );
        } else {
            this.msg = this.lbl.confirm_redeem.default;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/components/Modal/Redeem/ConfirmRedeem/Component/cfModal.scss";
</style>
